import { Schema as S } from "effect";

import { Direction } from "./ledger";

export const DeveloperCreditAdjustment = S.Struct({
	direction: Direction,
	amount: S.String,
	created: S.Boolean,
	entryId: S.String,
	balance: S.String,
	formattedBalance: S.String,
});

export const GeneratedDataDeletion = S.Struct({
	success: S.Boolean,
	deletedEvents: S.Number,
});
